import { Link } from "react-router-dom";

export default function ToolCard({
  title,
  description,
  category,
  path,
}) {
  return (
    <Link
      to={path}
      className="tool-card"
    >
      <div className="tool-category">
        {category}
      </div>

      <h2>{title}</h2>

      <p>{description}</p>
    </Link>
  );
}